import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { hideAddFormResults } from 'actions';

class ModalWrapper extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    headerClose: PropTypes.bool,
    isOpen: PropTypes.bool,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    subTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    dispatch: PropTypes.func.isRequired,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    shouldCloseOnOverlayClick: PropTypes.bool,
    showFooter: PropTypes.bool,
    showCancel: PropTypes.bool,
    disableConfirm: PropTypes.func,
    btnConfirmTitle: PropTypes.string,
    btnConfirmClass: PropTypes.string,
    btnCancelTitle: PropTypes.string,
    btnCancelClass: PropTypes.string,
    modalSize: PropTypes.string,
    formId: PropTypes.string,
    addingFormResults: PropTypes.shape({
      error: PropTypes.shape({
        code: PropTypes.number,
        message: PropTypes.string,
      }),
      success: PropTypes.bool,
      files: PropTypes.shape()
    }),
    useDummySubmit: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    headerClose: true,
    isOpen: false,
    title: 'Modal title',
    subTitle: null,
    onAfterOpen: null,
    onRequestClose: null,
    onConfirm: () => {},
    onCancel: () => {},
    shouldCloseOnOverlayClick: true,
    showFooter: true,
    showCancel: true,
    disableConfirm: () => false,
    btnConfirmTitle: 'Submit',
    btnConfirmClass: 'btn-primary',
    btnCancelTitle: 'Cancel',
    btnCancelClass: '',
    modalSize: '',
    formId: '',
    addingFormResults: null,
    useDummySubmit: false,
    className: ''
  };

  hideError() {
    const { dispatch } = this.props;
    dispatch(hideAddFormResults());
  }

  render() {
    const {
      isOpen,
      onAfterOpen,
      onRequestClose,
      modalSize,
      formId,
      shouldCloseOnOverlayClick,
      headerClose,
      onConfirm,
      onCancel,
      title,
      subTitle,
      children,
      showFooter,
      showCancel,
      disableConfirm,
      btnConfirmClass,
      btnConfirmTitle,
      btnCancelClass,
      btnCancelTitle,
      addingFormResults,
      useDummySubmit,
      className
    } = this.props;
    /* eslint-disable react/button-has-type */
    return (
      <Modal
        isOpen={ isOpen }
        onAfterOpen={ onAfterOpen }
        onRequestClose={ onRequestClose }
        contentLabel="Modal window"
        className={ `modal active ${ modalSize } ${ formId } ${ className }` }
        shouldCloseOnOverlayClick={ shouldCloseOnOverlayClick }
      >
        <div className="modal-overlay" />
        <div className="modal-container">
          <div className="modal-header">
            { headerClose && <button type="button" className="btn btn-clear float-right" onClick={ () => onCancel() } /> }
            <div className="modal-title">{ title }</div>
            {subTitle && <div>{ subTitle }</div>}
          </div>
          <div className="modal-body">
            <div className="content">
              { children }
            </div>
          </div>
          { showFooter && <div className="modal-footer">
            { addingFormResults && !addingFormResults.success && addingFormResults.error && <div><div className="toast toast-error">
              <button type="button" onClick={ () => this.hideError() } className="btn btn-clear float-right" />
              { addingFormResults.error.message }
            </div></div> }
            { showCancel && <button
              type="button"
              data-testid="btn-modal-cancel"
              className={ `btn btn-link ${ btnCancelClass }` }
              onClick={ () => onCancel() }
            >{ btnCancelTitle }</button> }
            <button
              type={ formId ? 'submit' : 'button' }
              form={ formId }
              className={ `btn ${ btnConfirmClass } ${ disableConfirm() ? 'disabled' : '' }` }
              onClick={ (e) => {
                if ((useDummySubmit || formId === 'uploadingPdfForm' || formId === 'uploadingPdfFormW8imy' || formId === 'pwdChgForm') && document.getElementById('dummy-add-form-btn') != null) {
                  document.getElementById('dummy-add-form-btn').click(); e.preventDefault();
                } else { onConfirm(e); }
              } }
              disabled={ disableConfirm() }
              data-testid="btn-modal-confirm"
            >
              { btnConfirmTitle }
            </button>
          </div> }
        </div>
      </Modal>
    );
    /* eslint-enable react/button-has-type */
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(ModalWrapper);
